module.exports = __webpack_public_path__ + "static/media/facebookreward.b6902068.svg";